export default {
  en: {
    title: 'Total practice time',
    loadingChart: 'Loading chart',
    emptyState: 'Not enough data yet',
    minutesOnly: '{{minutes}} min',
    hoursOnly: '{{hours}} h',
    hoursAndMinutes: '{{hours}} h {{minutes}} min',
    axisHours: '{{hours}}h',
    axisMinutes: '{{minutes}}m',
    tooltipPractice: '{{duration}} of practice',
    tooltipTotal: '{{duration}} total this period',
  },
  ru: {
    title: 'Общее время практики',
    loadingChart: 'Загружаю график',
    emptyState: 'Пока недостаточно данных',
    minutesOnly: '{{minutes}} мин',
    hoursOnly: '{{hours}} ч',
    hoursAndMinutes: '{{hours}} ч {{minutes}} мин',
    axisHours: '{{hours}}ч',
    axisMinutes: '{{minutes}}м',
    tooltipPractice: '{{duration}} практики',
    tooltipTotal: '{{duration}} всего за период',
  },
  de: {
    title: 'Gesamte Übungszeit',
    loadingChart: 'Diagramm wird geladen',
    emptyState: 'Noch nicht genug Daten',
    minutesOnly: '{{minutes}} Min.',
    hoursOnly: '{{hours}} Std.',
    hoursAndMinutes: '{{hours}} Std. {{minutes}} Min.',
    axisHours: '{{hours}}h',
    axisMinutes: '{{minutes}}m',
    tooltipPractice: '{{duration}} geübt',
    tooltipTotal: '{{duration}} insgesamt in diesem Zeitraum',
  },
  pt: {
    title: 'Tempo total de prática',
    loadingChart: 'Carregando gráfico',
    emptyState: 'Ainda não há dados suficientes',
    minutesOnly: '{{minutes}} min',
    hoursOnly: '{{hours}} h',
    hoursAndMinutes: '{{hours}} h {{minutes}} min',
    axisHours: '{{hours}}h',
    axisMinutes: '{{minutes}}m',
    tooltipPractice: '{{duration}} de prática',
    tooltipTotal: '{{duration}} no total neste período',
  },
  fr: {
    title: 'Temps total de pratique',
    loadingChart: 'Chargement du graphique',
    emptyState: 'Pas encore assez de données',
    minutesOnly: '{{minutes}} min',
    hoursOnly: '{{hours}} h',
    hoursAndMinutes: '{{hours}} h {{minutes}} min',
    axisHours: '{{hours}}h',
    axisMinutes: '{{minutes}}m',
    tooltipPractice: '{{duration}} de pratique',
    tooltipTotal: '{{duration}} au total sur cette période',
  },
  es: {
    title: 'Tiempo total de práctica',
    loadingChart: 'Cargando gráfico',
    emptyState: 'Todavía no hay suficientes datos',
    minutesOnly: '{{minutes}} min',
    hoursOnly: '{{hours}} h',
    hoursAndMinutes: '{{hours}} h {{minutes}} min',
    axisHours: '{{hours}}h',
    axisMinutes: '{{minutes}}m',
    tooltipPractice: '{{duration}} de práctica',
    tooltipTotal: '{{duration}} en total en este período',
  },
};
